import { Radio, Button } from 'antd';
import React, { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { LayoutForm } from './flota';
import Mantencion from './mantencion';
import Repuesto from './repuesto';
import Vehiculo from './vehiculo';


const Generico = ({ states }) => {
    const [component, setComponent] = useState(<Vehiculo states={states} />);
    const [cotizar, setCotizar] = useState("vehiculo");

    const changeCotizar = (e) => {
        const valor = e.target.value;
        states.setProducto(undefined);
        setCotizar(valor);
        if (valor === "vehiculo") {
            setComponent(<Vehiculo states={states} />)
            return;
        }
        if (valor === "repuesto") {
            setComponent(<Repuesto states={states} />)
            return;
        }
        if (valor === "mantencion") {
            setComponent(<Mantencion states={states} />)
        }

    }

    useEffect(() => {
        if (states.formProducto) {
            let state = states.formProducto;

            if (state.tipo === 'mantencion') {
                setCotizar(state.tipo);
                setComponent(<Mantencion states={states} />)
            }

        }
    }, [states.formProducto])

    return (
        <>
            <LayoutForm>
                <h5 className="bold-title-hyundai f-responsive mt-2 mt-md-0 mb-3">¿Qué necesitas cotizar?</h5>
                <Radio.Group value={cotizar} className="w-100" onChange={changeCotizar}>
                    <Row>
                        <Col xs={4}>
                            <Radio className="parrafo-hyundai f-responsive mr-0" value={"vehiculo"}>Vehículo</Radio>
                        </Col>
                        <Col xs={4} className='p-0'>
                            <Radio className="parrafo-hyundai f-responsive mr-0" value={"repuesto"}>Repuestos</Radio>
                        </Col>
                        <Col xs={4} className='p-0'>
                            <Radio className="parrafo-hyundai f-responsive mr-0" value={"mantencion"}>Mantenciones</Radio>
                        </Col>
                    </Row>
                </Radio.Group>
            </LayoutForm>
            {component}
        </>
    );
}

export default Generico;